module.exports = __webpack_public_path__ + "media/images/icon-pin-gray-e813fbb787f985732652e4331f61fb94.svg";